module.exports = __webpack_public_path__ + "assets/img/img330.66748373.png";